export const getCurrentDateTime = async () => {
  const response = await fetch('/favicon.ico')
  return new Date(response.headers.get('Date'))
}
